import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from './Texte';
import { UserRound } from './icons';
import { IconPill } from './IconPill';
import { colors, radius, spacing, typography } from '../theme/tokens';

export interface MessageBubbleProps {
  role: 'recruiter' | 'user';
  text: string;
  testID?: string;
}

// Bulle de conversation façon messagerie : recruteur à gauche (avatar pastille, fond clair),
// utilisateur à droite (fond bleu, texte blanc). Le coin « bas » côté locuteur est cassé.
export function MessageBubble({ role, text, testID }: MessageBubbleProps) {
  const isUser = role === 'user';

  return (
    <View
      testID={testID}
      style={[styles.row, isUser ? styles.rowUser : styles.rowRecruiter]}
    >
      {!isUser ? (
        <IconPill
          icon={UserRound}
          accent="blue"
          variant="soft"
          size={32}
          testID={testID ? `${testID}-avatar` : undefined}
        />
      ) : null}
      <View
        testID={testID ? `${testID}-bubble` : undefined}
        style={[styles.bubble, isUser ? styles.bubbleUser : styles.bubbleRecruiter]}
      >
        <Text style={[styles.text, isUser ? styles.textUser : styles.textRecruiter]}>{text}</Text>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  row: { flexDirection: 'row', alignItems: 'flex-end', gap: spacing.sm, maxWidth: '92%' },
  rowRecruiter: { alignSelf: 'flex-start' },
  rowUser: { alignSelf: 'flex-end' },
  bubble: { flexShrink: 1, borderRadius: radius.lg, paddingHorizontal: spacing.md, paddingVertical: spacing.sm },
  bubbleRecruiter: {
    backgroundColor: colors.white,
    borderWidth: 1,
    borderColor: colors.grey200,
    borderBottomStartRadius: 4,
  },
  bubbleUser: { backgroundColor: colors.bluePrimary, borderBottomEndRadius: 4 },
  text: { fontSize: typography.body.size, lineHeight: typography.body.lineHeight },
  textRecruiter: { color: colors.grey900 },
  textUser: { color: colors.white },
});
